var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTornado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 4.25L22.5771 4.25391C22.9551 4.29253 23.25 4.61184 23.25 5C23.25 5.38817 22.9551 5.70747 22.5771 5.7461L22.5 5.75L1.5 5.75C1.08579 5.75 0.75 5.41421 0.75 5C0.75 4.58579 1.08579 4.25 1.5 4.25L22.5 4.25Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7.25L18.5771 7.25391C18.9551 7.29253 19.25 7.61184 19.25 8C19.25 8.38817 18.9551 8.70747 18.5771 8.7461L18.5 8.75L4.5 8.75C4.08579 8.75 3.75 8.41421 3.75 8C3.75 7.58579 4.08579 7.25 4.5 7.25L18.5 7.25Z",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10.25L19.5771 10.2539C19.9551 10.2925 20.25 10.6118 20.25 11C20.25 11.3882 19.9551 11.7075 19.5771 11.7461L19.5 11.75L8.5 11.75C8.08579 11.75 7.75 11.4142 7.75 11C7.75 10.5858 8.08579 10.25 8.5 10.25L19.5 10.25Z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13.25L18.5771 13.2539C18.9551 13.2925 19.25 13.6118 19.25 14C19.25 14.3882 18.9551 14.7075 18.5771 14.7461L18.5 14.75L11.5 14.75C11.0858 14.75 10.75 14.4142 10.75 14C10.75 13.5858 11.0858 13.25 11.5 13.25L18.5 13.25Z",
    fill: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.25C16.9142 16.25 17.25 16.5858 17.25 17C17.25 17.4142 16.9142 17.75 16.5 17.75L12.5 17.75C12.0858 17.75 11.75 17.4142 11.75 17C11.75 16.5858 12.0858 16.25 12.5 16.25L16.5 16.25Z",
    fill: "#263238"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.25L12.5771 19.2539C12.9551 19.2925 13.25 19.6118 13.25 20C13.25 20.3882 12.9551 20.7075 12.5771 20.7461L12.5 20.75H11.5C11.0858 20.75 10.75 20.4142 10.75 20C10.75 19.5858 11.0858 19.25 11.5 19.25H12.5Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTornado);
export default __webpack_public_path__ + "static/media/Tornado.5639a1b566818155d39c73c00703737a.svg";
export { ForwardRef as ReactComponent };